/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CandidateMatchComponentTypeDto = {
    MainAnalysis: 'MAIN_ANALYSIS',
    IndustryExperience: 'INDUSTRY_EXPERIENCE',
    CompanyLoyalty: 'COMPANY_LOYALTY'
} as const;

export type CandidateMatchComponentTypeDto = typeof CandidateMatchComponentTypeDto[keyof typeof CandidateMatchComponentTypeDto];



